<div
  mat-dialog-title
  class="modal-header text-white pl-3 pr-3 pt-2 pb-2 mb-0"
  fxLayoutAlign="space-between center"
>
  <div fxLayout="row" fxLayoutAlign="start center">
    <strong style="font-size: 15px;">Download Reports</strong>
  </div>
  <span style="font-size: 31px; cursor: pointer;" mat-dialog-close
    >&times;</span
  >
</div>

<mat-dialog-content
  fxLayout="column"
  [formGroup]="reportForm"
  class="container-modal-report"
>
  <section fxLayout="row" style="height: 50px;">
    <span fxFlex="30" fxLayoutAlign="start center" class="label-data"
      >Report:
    </span>
    <div fxFlex="70" fxLayoutAlign="start center">
      <mat-form-field
        fxFlex="90"
        class="select-ship font-weight-filters"
        appearance="none"
      >
        <mat-select
          class="selector-shipper"
          placeholder="Select a report"
          formControlName="report_config"
          *ngIf="
            user &&
            user.role &&
            ['super_admin', 'account_receivable'].includes(user.role.name)
          "
        >
          <ng-container *ngFor="let report of reports">
            <mat-option
              [value]="report"
              [disabled]="!report.active"
              *ngIf="report.roles.includes(user.role.name)"
            >
              <span>{{ report.name | titlecase }}</span>
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-select
          class="selector-shipper"
          placeholder="Select a report"
          formControlName="report_config"
          *ngIf="
            user &&
            user.role &&
            !['super_admin', 'account_receivable','account_payable'].includes(user.role.name)
          "
        >
          <ng-container *ngFor="let report of reports">
            <mat-option [value]="report" [disabled]="!report.active">
              <span>{{ report.name | titlecase }}</span>
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-select
          class="selector-shipper"
          placeholder="Select a report"
          formControlName="report_config"
          *ngIf="
            user &&
            user.role &&
            ['account_payable'].includes(user.role.name)
          "
        >
          <ng-container *ngFor="let report of reportsAccountPayable">
            <mat-option [value]="report" [disabled]="!report.active">
              <span>{{ report.name | titlecase }}</span>
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
  </section>

  <section fxLayout="row" style="height: 65px; margin-bottom: 8px;">
    <span fxFlex="30" fxLayoutAlign="start center" class="label-data"
      >Date range:
    </span>
    <div fxFlex="70" fxLayout="column" fxLayoutGap="5px">
      <div fxLayout="row">
        <input
          fxFlex="90"
          type="text"
          class="general-input"
          maxlength="250"
          formControlName="start_date"
          placeholder="Start date"
          [matDatepicker]="picker"
          [max]="reportForm.get('end_date').value"
          (click)="picker.open()"
          readonly
          appDisableAutofill
        />
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div fxLayout="row">
        <input
          fxFlex="90"
          type="text"
          class="general-input"
          maxlength="250"
          formControlName="end_date"
          placeholder="End date"
          [min]="reportForm.get('start_date').value"
          [disabled]="!reportForm.get('start_date').value"
          [matDatepicker]="pickerEnd"
          (click)="pickerEnd.open()"
          readonly
          appDisableAutofill
        />
        <mat-datepicker #pickerEnd></mat-datepicker>
      </div>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="center" style="margin-bottom: 0 !important">
  <button
    class="buttonAccept font-weight-filters font-size-filters"
    mat-button
    (click)="generateReport()"
    [class.buttonDisabled]="!reportForm.valid || isRequesting"
    [disabled]="!reportForm.valid || isRequesting"
  >
    Generate Report
  </button>
  <div [ngStyle]="{ height: '35px' }" fxLayoutAlign="center center">
    <mat-spinner
      *ngIf="isRequesting"
      class="loading-spinner"
      diameter="30"
    ></mat-spinner>
  </div>
</mat-dialog-actions>
